<template>
    <div>
        <Accordion
            v-for="accordion in accordions"
            :key="accordion.title"
            :title="accordion.title"
            :content="accordion.body"
        >
           {{ accordion.body }}
        </Accordion>
    </div>
</template>

<script>
import Accordion from 'templates/components/Accordion';

export default {
    name: 'block-accordions',
    components: {
        Accordion,
    },
    props: {
        accordions: {
            type: Array,
        },
    },
};
</script>
